// extracted by mini-css-extract-plugin
module.exports = {"notFound":"NotFound--notFound--fY4AyEq","refreshButton":"NotFound--refreshButton--jxvZ8a2"};